import React, { createContext, useCallback, useContext, useMemo, useState } from "react";
import { toast } from "sonner";

const CartContext = createContext(null);

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);

  const addItem = useCallback((entry) => {
    setItems((prev) => [...prev, { ...entry, cartId: Math.random().toString(36).slice(2) }]);
    toast.success(`Added ${entry.name} to your cart!`);
  }, []);

  const removeItem = useCallback((cartId) => setItems((p) => p.filter((i) => i.cartId !== cartId)), []);

  const updateQty = useCallback((cartId, qty) =>
    setItems((p) => p.map((i) => (i.cartId === cartId ? { ...i, quantity: Math.max(1, qty), lineTotal: i.unitPrice * Math.max(1, qty) } : i))), []);

  const clear = useCallback(() => setItems([]), []);

  const count = useMemo(() => items.reduce((a, i) => a + i.quantity, 0), [items]);
  const subtotal = useMemo(() => items.reduce((a, i) => a + i.lineTotal, 0), [items]);

  const value = useMemo(
    () => ({ items, addItem, removeItem, updateQty, clear, count, subtotal, open, setOpen }),
    [items, addItem, removeItem, updateQty, clear, count, subtotal, open]
  );

  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
};

export const useCart = () => useContext(CartContext);
